module.exports = __webpack_public_path__ + "img/penguin.515d6f87.png";